/* ============================================================
   PRISMAX — Shopify-native cart engine
   Replaces the prototype's localStorage cart with the real
   Shopify AJAX Cart API. Reuses the prototype drawer DOM/CSS
   (.px-drawer etc.) + free-ship bar + upsell + email pop-ups.
   Add buttons: any [data-add] with data-variant-id (+ optional
   data-qty), or a <form action*="/cart/add">. "Add all" supported
   via [data-add-all] wrapping multiple [data-variant-id] nodes.
   ============================================================ */
(function () {
  var FREE_SHIP = window.PRISMAX_FREE_SHIP || 99900; // cents
  // Merchant-editable copy from Theme settings (injected by theme.liquid); fallbacks = shipped copy
  var C = window.PRISMAX_COPY || {}, CP = C.popup || {};
  var POP_DELAY = 14000, POP_COOLDOWN = 3 * 864e5, CODE = CP.code || 'WELCOME200', AMT = CP.amount || 'Rs. 200';
  var routes = (window.PRISMAX_ROUTES || {});
  var cartAdd = routes.cart_add || '/cart/add.js';
  var cartChange = routes.cart_change || '/cart/change.js';
  var cartUrl = routes.cart || '/cart.js';

  function rs(cents) { return (window.prismaxMoney ? window.prismaxMoney(cents) : '₹' + Math.round((cents || 0) / 100).toLocaleString('en-IN')); }
  function phImg(src) { return src ? '<img src="' + src + '" alt="" loading="lazy">' : ''; }

  // ---- inject UI (mirrors prototype structure so prismax-shop.css applies) ----
  var root = document.createElement('div');
  root.innerHTML = [
    '<div class="px-ov" data-px-ov></div>',
    '<aside class="px-drawer" data-px-drawer aria-label="Cart" role="dialog" aria-modal="true">',
    '  <div class="pxd-head"><div class="ttl">' + (C.title || 'Your bay') + ' <span class="n" data-px-count>(0)</span></div><button class="pxd-close" data-px-close aria-label="Close">✕</button></div>',
    '  <div class="px-ship" data-px-ship><div class="msg"></div><div class="track"><div class="fill"></div></div></div>',
    '  <div class="pxd-body" data-px-body></div>',
    '  <div data-px-upsell></div>',
    '  <div class="pxd-foot" data-px-foot></div>',
    '</aside>',
    '<div class="px-toast" data-px-toast><span class="dot"></span><span data-px-toast-msg>' + (C.toast || 'Added to bay') + '</span></div>',
    '<div class="px-pop" data-px-pop><div class="px-pop-bg" data-px-pop-close></div><div class="px-pop-card" data-px-pop-card></div></div>'
  ].join('');
  document.body.appendChild(root);

  var ov = root.querySelector('[data-px-ov]'),
      drawer = root.querySelector('[data-px-drawer]'),
      body = root.querySelector('[data-px-body]'),
      shipBox = root.querySelector('[data-px-ship]'),
      foot = root.querySelector('[data-px-foot]'),
      countEl = root.querySelector('[data-px-count]'),
      toast = root.querySelector('[data-px-toast]'),
      toastMsg = root.querySelector('[data-px-toast-msg]'),
      pop = root.querySelector('[data-px-pop]'),
      popCard = root.querySelector('[data-px-pop-card]');

  function openDrawer() { ov.classList.add('open'); drawer.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { ov.classList.remove('open'); drawer.classList.remove('open'); document.body.style.overflow = ''; }
  root.querySelector('[data-px-close]').addEventListener('click', closeDrawer);
  ov.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  var toastT;
  function showToast(msg) { toastMsg.textContent = msg || C.toast || 'Added to bay'; toast.classList.add('show'); clearTimeout(toastT); toastT = setTimeout(function () { toast.classList.remove('show'); }, 2400); }

  // ---- Shopify cart API ----
  function getCart() { return fetch(cartUrl, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function addItems(items) {
    return fetch(cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
  }
  function changeLine(key, qty) {
    return fetch(cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); });
  }

  function setCounts(n) {
    countEl.textContent = '(' + n + ')';
    // hide the header badge at zero rather than showing a "0" bubble
    document.querySelectorAll('.cc').forEach(function (c) { c.textContent = n; c.classList.toggle('is-empty', !n); });
  }

  // ---- render drawer from a cart object ----
  function render(cart) {
    setCounts(cart.item_count);
    var sub = cart.items_subtotal_price;
    var msg = shipBox.querySelector('.msg'), fill = shipBox.querySelector('.fill');
    if (sub >= FREE_SHIP) { msg.className = 'msg done'; msg.innerHTML = (C.shipDone || '✓ You\'ve unlocked <b>FREE express shipping</b>'); fill.className = 'fill done'; fill.style.width = '100%'; }
    else { var rem = FREE_SHIP - sub; msg.className = 'msg'; msg.innerHTML = sub === 0 ? (C.shipZero || 'Spend <b>[amount]</b> to unlock <b>FREE shipping</b>').replace('[amount]', rs(FREE_SHIP)) : (C.shipProgress || 'You\'re <b>[amount]</b> away from <b>FREE shipping</b>').replace('[amount]', rs(rem)); fill.className = 'fill'; fill.style.width = Math.max(4, (sub / FREE_SHIP) * 100) + '%'; }

    if (!cart.item_count) {
      shipBox.style.display = 'none';
      body.innerHTML = '<div class="px-empty"><div class="ic">⛉</div><h4>' + (C.emptyHeading || 'Your bay is empty.') + '</h4><p>' + (C.emptyText || 'Add a coating, a compound or a wash kit — and build toward free shipping.') + '</p><a class="btn btn-primary" href="/collections/all">' + (C.emptyCta || 'Shop products') + '</a>' +
        (C.waNumber ? '<a class="btn btn-ghost" style="margin-top:10px" href="https://wa.me/' + C.waNumber + '" target="_blank" rel="noopener">' + (C.waLabel || 'Chat with a detailer') + '</a>' : '') +
        '</div><div data-px-best></div>';
      foot.innerHTML = '';
      // never a dead-end: surface bestsellers from the configured collection
      fetch('/collections/' + (C.emptyCollection || 'frontpage') + '/products.json?limit=3', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var ps = (d.products || []).slice(0, 3); if (!ps.length) return;
          var holder = body.querySelector('[data-px-best]'); if (!holder) return;
          holder.innerHTML = '<div class="px-upsell"><div class="uh">' + (C.upsellHeading || 'Complete the job · add-ons') + '</div>' + ps.map(function (p) {
            var v0 = (p.variants && p.variants[0]) || {};
            var img = (p.images && p.images[0] && p.images[0].src) ? '<img src="' + p.images[0].src.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="" loading="lazy">' : '';
            return '<div class="px-up"><div class="uth"><div class="ph">' + img + '</div></div><div><div class="un">' + p.title + '</div><div class="upr">' + rs(Math.round(parseFloat(v0.price || 0) * 100)) + '</div></div><button class="uadd" data-variant-id="' + (v0.id || '') + '" data-add>Add +</button></div>';
          }).join('') + '</div>';
        }).catch(function () {});
      return;
    }
    shipBox.style.display = '';
    body.innerHTML = cart.items.map(function (it) {
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="vr">' + it.variant_title + '</div>' : '';
      var benefit = C.lineNote ? '<div class="px-benefit">' + C.lineNote + '</div>' : '';
      return '<div class="px-line"><div class="px-thumb"><div class="ph">' + phImg(it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '') + '</div></div>' +
        '<div><div class="nm">' + it.product_title + '</div>' + variant + benefit +
        '<div class="px-qty"><button data-ck="' + it.key + '" data-q="' + (it.quantity - 1) + '">−</button><span>' + it.quantity + '</span><button data-ck="' + it.key + '" data-q="' + (it.quantity + 1) + '">+</button></div></div>' +
        '<div class="rt"><div class="pr">' + rs(it.final_line_price) + '</div><button class="rm" data-ck="' + it.key + '" data-q="0">Remove</button></div></div>';
    }).join('');

    foot.innerHTML = '<div class="row"><span class="lbl">Subtotal</span><span class="val">' + rs(sub) + '</span></div>' +
      '<div class="row"><span class="lbl">Shipping</span><span class="val">' + (sub >= FREE_SHIP ? 'Free' : 'Calculated next') + '</span></div>' +
      '<div class="row total"><span class="lbl">Total</span><span class="val">' + rs(cart.total_price) + '</span></div>' +
      // Checkout MUST be a real cart-form submit named "checkout". GoKwik (kwikpass) and
      // every other checkout app binds to that standard control; a bare <a href="/checkout">
      // is invisible to them and drops the customer into native Shopify checkout, bypassing
      // GoKwik entirely. If no app is active this posts to /cart and Shopify routes it to
      // checkout as normal, so the fallback behaviour is unchanged.
      '<form action="/cart" method="post" novalidate class="pxd-checkout-form">' +
        '<button type="submit" name="checkout" class="btn btn-primary">' + (C.checkoutLabel || 'Checkout') + ' · ' + rs(cart.total_price) + '</button>' +
      '</form>' +
      '<button class="btn btn-ghost" data-px-continue style="width:100%;margin-top:10px">' + (C.continueLabel || 'Continue shopping') + '</button>' +
      '<div class="fine">' + (C.fine || 'Secure checkout · 7-day returns · prepaid 10% off up to ₹250') + '</div>';

    renderUpsell(cart);
  }

  function renderUpsell(cart) {
    if (!cart.items.length) return;
    var pid = cart.items[0].product_id;
    var have = cart.items.map(function (i) { return i.product_id; });
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=6&intent=related', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var sug = (d.products || []).filter(function (p) { return have.indexOf(p.id) === -1 && p.available; }).slice(0, 3);
        if (!sug.length) return;
        var html = '<div class="px-upsell"><div class="uh">' + (C.upsellHeading || 'Complete the job · add-ons') + '</div>' + sug.map(function (p) {
          var vid = (p.variants && p.variants[0]) ? p.variants[0].id : '';
          return '<div class="px-up"><div class="uth"><div class="ph">' + phImg(p.featured_image ? p.featured_image + '&width=120' : '') + '</div></div><div><div class="un">' + p.title + '</div><div class="upr">' + rs(p.price) + '</div></div><button class="uadd" data-variant-id="' + vid + '" data-add>Add +</button></div>';
        }).join('') + '</div>';
        var holder = document.createElement('div'); holder.innerHTML = html;
        body.appendChild(holder.firstChild);
      }).catch(function () {});
  }

  function refresh(open) { return getCart().then(function (c) { render(c); if (open) openDrawer(); return c; }); }

  // ---- delegated drawer qty/remove ----
  drawer.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ck]');
    if (t) { changeLine(t.getAttribute('data-ck'), +t.getAttribute('data-q')).then(render); return; }
    if (e.target.closest('[data-px-continue]')) closeDrawer();
    if (e.target.closest('[name="checkout"], a[href="/checkout"]')) {
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'begin_checkout' }); } catch (er) {}
    }
  });

  // ---- add-to-cart hooks ----
  function collectItems(btn) {
    // "Add all" container
    var all = btn.closest('[data-add-all]');
    if (all) {
      return [].slice.call(all.querySelectorAll('[data-variant-id]')).map(function (n) {
        return { id: +n.getAttribute('data-variant-id'), quantity: +(n.getAttribute('data-qty') || 1) };
      }).filter(function (i) { return i.id; });
    }
    // product form (PDP)
    var form = btn.closest('form[action*="/cart/add"]');
    if (form) {
      var sel = form.querySelector('[name="id"]');
      var qtyEl = form.querySelector('[name="quantity"]');
      if (sel && sel.value) return [{ id: +sel.value, quantity: +(qtyEl && qtyEl.value || 1) }];
    }
    // simple data-variant-id button
    var vid = btn.getAttribute('data-variant-id');
    if (vid) {
      var qbox = btn.closest('.buy, .sticky-buy, [data-buybox]');
      var qv = qbox ? qbox.querySelector('[data-qty] .qv') : null;
      return [{ id: +vid, quantity: qv ? (parseInt(qv.textContent, 10) || 1) : 1 }];
    }
    return null;
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-add]');
    if (addBtn) {
      var items = collectItems(addBtn);
      if (!items || !items.length) { return; } // no variant → let normal link/href work
      e.preventDefault();
      addBtn.classList.add('is-loading');
      var buyNow = addBtn.hasAttribute('data-buynow');
      addItems(items)
        .then(function () {
          // analytics: standard ecommerce event for GTM consumers (channels fire their own)
          try { (window.dataLayer = window.dataLayer || []).push({ event: 'add_to_cart', items: items.map(function (i) { return { item_id: i.id, quantity: i.quantity }; }) }); } catch (e) {}
          // Buy it now: submit a real cart form so GoKwik can intercept, rather than
          // navigating straight to /checkout which would bypass it.
          if (buyNow) {
            var f = document.createElement('form');
            f.method = 'post'; f.action = '/cart';
            var i = document.createElement('input');
            i.type = 'hidden'; i.name = 'checkout'; i.value = '1';
            f.appendChild(i); document.body.appendChild(f); f.submit();
            return;
          }
          return refresh(true).then(function () { showToast('Added to bay'); });
        })
        .catch(function (err) { showToast((err && err.description) || 'Sorry, that could not be added'); })
        .then(function () { addBtn.classList.remove('is-loading'); });
      return;
    }
    var cartIcon = e.target.closest('.icon-btn[title="Cart"], [data-px-open]');
    if (cartIcon) { e.preventDefault(); refresh(true); }
  }, false);

  // ================= EMAIL POP-UPS (ported from prototype) =================
  function popClose() { pop.classList.remove('open'); document.body.style.overflow = ''; }
  function markSeen() { try { localStorage.setItem('prismax-pop-seen', String(Date.now())); } catch (e) {} }
  function subscribed() { try { return !!localStorage.getItem('prismax-sub'); } catch (e) { return false; } }
  function canPop() { if (subscribed()) return false; try { var t = +localStorage.getItem('prismax-pop-seen') || 0; if (Date.now() - t < POP_COOLDOWN) return false; } catch (e) {} return true; }
  function emailForm(exit) {
    return [
      '<button class="px-pop-close" data-px-pop-close>✕</button>',
      '<div class="px-pop-visual"><div class="ph ph-violet"></div><span class="tag tag-ink vtag">DER NEUE STANDARD</span>',
      '  <div class="vquote">' + (exit ? (CP.headingExit || 'Before you go —<br>here\'s Rs. 200 off.') : (CP.headingVisual || 'Join Join the Prismax list.')) + '</div></div>',
      '<div class="px-pop-body">',
      '  <div class="eyebrow"><span class="dot"></span>' + (exit ? 'WAIT · ONE THING' : 'MEMBER OFFER') + '</div>',
      '  <h3>Get <span class="ac">' + AMT + ' off</span> your first order.</h3>',
      '  <p>' + (CP.body || 'Join the Prismax list for detailing guides, member drops and new innovations. We\'ll email your code instantly.') + '</p>',
      '  <form data-px-email><input type="email" required placeholder="Enter your email address…"><button class="btn btn-primary" type="submit">' + (CP.button || 'Email my [amount] code').replace('[amount]', AMT) + '</button></form>',
      '  <button class="nope" data-px-pop-close>' + (CP.decline || 'No thanks, I\'ll pay full price') + '</button>',
      '</div>'
    ].join('');
  }
  function showPop(exit) {
    if (CP.enabled === false) return;
    if (!canPop() || pop.classList.contains('open')) return;
    popCard.className = 'px-pop-card'; popCard.innerHTML = emailForm(exit);
    pop.classList.add('open'); document.body.style.overflow = 'hidden'; markSeen();
  }
  pop.addEventListener('click', function (e) {
    if (e.target.closest('[data-px-pop-close]')) { popClose(); return; }
    if (e.target.closest('button[type="submit"]')) {
      var f = popCard.querySelector('[data-px-email]'), input = f.querySelector('input');
      if (!input.value || input.value.indexOf('@') === -1) { e.preventDefault(); input.focus(); return; }
      e.preventDefault();
      try { localStorage.setItem('prismax-sub', input.value); } catch (er) {}
      // best-effort newsletter signup against Shopify customer endpoint
      var fd = new FormData(); fd.append('form_type', 'customer'); fd.append('utf8', '✓'); fd.append('contact[tags]', 'newsletter,popup'); fd.append('contact[email]', input.value);
      fetch('/contact', { method: 'POST', body: fd }).catch(function () {});
      popCard.className = 'px-pop-card'; popCard.style.gridTemplateColumns = '1fr';
      popCard.innerHTML = '<button class="px-pop-close" data-px-pop-close>✕</button><div class="px-pop-success"><div class="chk">✓</div><h3>' + (CP.successHeading || 'You\'re in.') + '</h3><p>' + (CP.successBody || 'Your code is below — it\'s also on its way to your inbox. Use it at checkout.') + '</p><div class="px-code">' + CODE + '</div><div style="margin-top:22px"><button class="btn btn-ink" data-px-pop-close>Start shopping</button></div></div>';
    }
  });
  setTimeout(function () { showPop(false); }, POP_DELAY);
  document.addEventListener('mouseleave', function (e) { if (e.clientY <= 0) showPop(true); });

  // ---- public API (used by Build Your Bay + custom triggers) ----
  window.PrismaxCart = {
    addItems: function (items) { return addItems(items).then(function () { return refresh(true); }); },
    open: function () { return refresh(true); },
    close: closeDrawer,
    refresh: function () { return refresh(false); },
    toast: showToast
  };

  // initial paint
  refresh(false);
})();
